import { Observable, Subject, Subscription } from 'rxjs';
/**
 * tapPipe creates a second subscription to the source Observable executing the pipeline of {@link operations}
 * provided to the operator but ignoring the results. The source Observable stream is passed down unchanged and is
 * proxied through a Subject to maintain a single chain.
 * @param operations pipeiline to execute on the tapped values (next, error, and complete)
 * @returns source Observable instrumented by a pipeline of side-effects
 */
export function tapPipe(...operations) {
    return (source$) => {
        return new Observable((sub) => {
            const subscription = new Subscription();
            // we will pass the source through the subject to avoid duplicating the chain
            const shareSubj = new Subject();
            // perform the splitting on the cold subject
            subscription.add(shareSubj.subscribe(sub)); // pass-through the original stream unmodified
            // eslint-disable-next-line prefer-spread
            subscription.add(shareSubj.pipe.apply(shareSubj, operations).subscribe()); // and activate (subscribe to) the tap pipeline
            // make the source hot
            subscription.add(source$.subscribe(shareSubj)); // ! only subscribe to source once !
            return subscription;
        });
    };
}
//# sourceMappingURL=tapPipe.js.map